module.exports = __webpack_public_path__ + "static/img/zeta_cr_template_09.44bbef7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/case/zeta_cr_template_09.png
// module id = vS92
// module chunks = 1